import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodos() {
        let url = `${api}/feriados`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(feriadoId) {
        let url = `${api}/feriados/${feriadoId}`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(feriadoDto) {
        let url = `${api}/feriados/inserir`
        return axiosJwt.post(url, feriadoDto)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(feriadoDto) {
        let url = `${api}/feriados/atualizar`
        return axiosJwt.post(url, feriadoDto)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluir(feriadoId) {
        let url = `${api}/feriados/excluir/${feriadoId}`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ativarDesativarFeriado(feriadoId) {
        let url = `${api}/feriados/ativardesativar/${feriadoId}`
        return axiosJwt
            .post(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
